import Plotly from 'plotly.js-dist-min';
import React, { useEffect, useRef } from 'react';

interface PlotlyViewerProps {
  plotJson: string;
}

const PlotlyViewer: React.FC<PlotlyViewerProps> = ({ plotJson }) => {
  const plotRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!plotRef.current) return;

    try {
      // Parse the Plotly JSON
      const plotData = JSON.parse(plotJson);
      
      // Plotly JSON format typically has {data: [...], layout: {...}, config: {...}}
      const { data, layout, config } = plotData;

      // Create the plot
      Plotly.newPlot(
        plotRef.current,
        data || [],
        layout || {},
        {
          responsive: true,
          displayModeBar: true,
          displaylogo: false,
          modeBarButtonsToRemove: [
            'lasso2d',
            'select2d',
            'zoom2d',
            'pan2d',
            'zoomIn2d',
            'zoomOut2d',
            'autoScale2d',
            'resetScale2d',
            'toImage'
          ],
          ...config
        }
      );
    } catch (error) {
      console.error('Error rendering Plotly plot:', error);
    }

    // Cleanup on unmount
    return () => {
      if (plotRef.current) {
        Plotly.purge(plotRef.current);
      }
    };
  }, [plotJson]);

  return (
    <div className="flex flex-col h-full">
      <div ref={plotRef} className="flex-1 p-4 min-h-[400px]" />
    </div>
  );
};

export default PlotlyViewer;
